import * as React from "react"
import type { OutletPoint } from "./OutletMapClient"

export type { OutletPoint }

// Leaflet touches window/document at module load, and SSR eagerly imports every
// page component — so the actual map lives in OutletMapClient and is pulled in
// only via a client-side dynamic import after mount. On the server (and on the
// first client render before hydration) we render a static placeholder, so
// Leaflet never runs during SSR.
const OutletMapClient = React.lazy(() => import("./OutletMapClient"))

function MapSkeleton() {
  return (
    <div className="flex h-[420px] w-full items-center justify-center rounded-lg border border-hairline bg-page text-sm text-ink-muted">
      Memuat peta…
    </div>
  )
}

export function OutletMap({ points }: { points: OutletPoint[] }) {
  const [mounted, setMounted] = React.useState(false)
  React.useEffect(() => setMounted(true), [])

  if (!mounted) return <MapSkeleton />

  return (
    <React.Suspense fallback={<MapSkeleton />}>
      <OutletMapClient points={points} />
    </React.Suspense>
  )
}
